export default {
	es: 'Español',
	en: 'English',
};
